import { ChargeConstants } from 'features/Charge/chargeHelper';
import SystemHelper, { SystemConstants } from 'features/System/systemHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

DialogUpdateEnergyBillView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogUpdateEnergyBillView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const isAdmin =
    user?.role === ChargeConstants.UserRole.ADMIN ||
    user?.role === ChargeConstants.UserRole.OPERATOR;
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [evnBeginningCycleCounter, setEvnBeginningCycleCounter] = useState('');
  const [evnEndingCycleCounter, setEvnEndingCycleCounter] = useState('');
  const [evnEnergyUsed, setEvnEnergyUsed] = useState('');
  const [amountBeforeTax, setAmountBeforeTax] = useState('');
  const [amountAfterTax, setAmountAfterTax] = useState('');
  const [taxRate, setTaxRate] = useState(10);
  const [evnInvoiceSerial, setEvnInvoiceSerial] = useState('');
  const [evnInvoiceSignature, setEvnInvoiceSignature] = useState('');
  const [evnInvoiceDocument, setEvnInvoiceDocument] = useState(null);

  useEffect(() => {
    if (item) {
      setEvnBeginningCycleCounter(item?.evnBeginingCycleCounter);
      setEvnEndingCycleCounter(item?.evnEndingCycleCounter);
      setEvnEnergyUsed(item?.evnEnergyUsed);
      setAmountBeforeTax(item?.amountBeforeTax);
      setTaxRate(Utils.isValid(item?.taxRate) ? _.toNumber(item?.taxRate * 100) : 10);
      setEvnInvoiceSerial(item?.evnInvoiceSerial);
      setEvnInvoiceSignature(item?.evnInvoiceSignature);
    }
  }, [item]);
  useEffect(() => {
    if (!Utils.isValid(amountBeforeTax)) return;

    const tax = Utils.isValid(taxRate) ? taxRate / 100 : 0;
    const total = amountBeforeTax * (1 + tax);

    // Làm tròn 2 chữ số sau dấu phẩy
    const rounded = Math.round(total * 100) / 100;

    setAmountAfterTax(rounded);
  }, [amountBeforeTax, taxRate]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    let params = {
      evnEndingCycleCounter: evnEndingCycleCounter,
      evnBeginingCycleCounter: evnBeginningCycleCounter,
      evnEnergyUsed: evnEnergyUsed,
      amountBeforeTax: amountBeforeTax,
      taxRate: taxRate / 100,
      amountAfterTax: amountAfterTax,
      evnInvoiceSerial: evnInvoiceSerial,
      evnInvoiceSignature: evnInvoiceSignature,
    };
    if (evnInvoiceDocument) {
      params.evnInvoiceDocument = await uploadAsyncFunction(evnInvoiceDocument);
    }
    if (isAdmin) {
      params.status = SystemConstants.EnergyBillStatus.PENDING;
    }
    console.log({ params });
    setLoading(true);
    const res = await SystemHelper.API.EnergyBill.requestUpdateEnergyBill(item?.billId, params);
    setLoading(false);
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Cập nhật hoá đơn thành công');
      onDone();
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
  };

  async function uploadAsyncFunction(file) {
    return new Promise((resolve) => {
      if (file instanceof File) {
        miscHelper.callApiUploadFile(file).then((mediaList) => {
          if (_.isArray(mediaList) && mediaList.length > 0) {
            const firstMedia = _.first(mediaList);
            const relativePath = firstMedia?.relativePath;
            if (relativePath) {
              resolve(relativePath);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        });
      } else {
        resolve(file);
      }
    });
  }

  useEffect(() => {
    const used = evnEndingCycleCounter - evnBeginningCycleCounter;
    setEvnEnergyUsed(used >= 0 ? used : 0);
  }, [evnEndingCycleCounter, evnBeginningCycleCounter]);

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('Số điện mới', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="kWh"
            placeholder="Nhập số"
            name="evnEndingCycleCounter"
            value={evnEndingCycleCounter}
            onChange={(value) => {
              setEvnEndingCycleCounter(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(evnEndingCycleCounter)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(evnEndingCycleCounter) ? 'Số điện mới không hợp lệ' : ''}
          />
        </div>
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('Số điện cũ', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="kWh"
            placeholder="Nhập số"
            name="evnBeginningCycleCounter"
            value={evnBeginningCycleCounter}
            onChange={(value) => {
              setEvnBeginningCycleCounter(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(evnBeginningCycleCounter)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(evnBeginningCycleCounter) ? 'Số điện cũ không hợp lệ' : ''}
          />
        </div>
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('Điện năng tiêu thụ', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="kWh"
            placeholder="Tự động tính"
            name="evnEnergyUsed"
            value={evnEnergyUsed}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(evnEnergyUsed)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(evnEnergyUsed) ? 'Điện năng tiêu thụ không hợp lệ' : ''}
          />
        </div>
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('HĐ tiền điện (trước thuế)', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="VNĐ"
            placeholder="Nhập số tiền"
            name="amountBeforeTax"
            value={amountBeforeTax}
            onChange={(value) => {
              setAmountBeforeTax(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(amountBeforeTax)}
            isTouched={readyToValidate}
            feedbackText={
              !Utils.isValid(amountBeforeTax) ? 'HĐ tiền điện (trước thuế) không hợp lệ' : ''
            }
          />
        </div>
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('Thuế suất', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="%"
            placeholder="Nhập số"
            name="taxRate"
            value={taxRate}
            onChange={(value) => {
              setTaxRate(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(taxRate)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(taxRate) ? 'Thuế suất không hợp lệ' : ''}
          />
        </div>
        <div className="col-lg-4 mb-4 px-2">
          {UIHelper.buildFormLabel('HĐ tiền điện (sau thuế)', true)}
          <KTFormInput
            type={KTFormInputType.currency}
            unit="VNĐ"
            placeholder="Nhập số tiền"
            name="amountAfterTax"
            value={amountAfterTax}
            onChange={(value) => {
              setAmountAfterTax(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(amountAfterTax)}
            isTouched={readyToValidate}
            feedbackText={
              !Utils.isValid(amountAfterTax) ? 'HĐ tiền điện (sau thuế) không hợp lệ' : ''
            }
            disabled={true}
          />
        </div>
        <div className="col-lg-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Số hoá đơn', true)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập số hoá đơn"
            name="evnInvoiceSerial"
            value={evnInvoiceSerial}
            onChange={(value) => {
              setEvnInvoiceSerial(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(evnInvoiceSerial)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(evnInvoiceSerial) ? 'Số hoá đơn không hợp lệ' : ''}
          />
        </div>
        <div className="col-lg-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Ký hiệu hoá đơn', true)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập ký hiệu hoá đơn"
            name="evnInvoiceSignature"
            value={evnInvoiceSignature}
            onChange={(value) => {
              setEvnInvoiceSignature(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(evnInvoiceSignature)}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(evnInvoiceSignature) ? 'Ký hiệu hoá đơn không hợp lệ' : ''}
          />
        </div>
        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel('Tải lên file hoá đơn')}
          <br />
          <label className="">
            {UIHelper.buildNegativeButton(
              'Thêm tập tin',
              () => { },
              <i className="fa-regular fa-upload" />
            )}
            <input
              type="file"
              accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
              onChange={(e) => {
                const files = e.target.files;
                if (!files || files.length === 0) return;
                const file = files[0];
                if (file.name.length > 128) {
                  ToastHelper.showError("Tên file quá dài! Tối đa cho phép 128 ký tự.");
                  e.target.value = null;
                  return;
                }
                setEvnInvoiceDocument(file);
              }}
              hidden
              onClick={(e) => {
                e.target.value = null;
              }}
            />
          </label>
          {evnInvoiceDocument && (
            <div className="d-flex align-items-center gap-2">
              <span
                className="text-ellipsis-2-lines"
                style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[700])}
              >
                {evnInvoiceDocument.name}
              </span>
              <i
                className="fa-regular fa-trash-can cursor-pointer hover-opacity-60"
                onClick={() => {
                  setEvnInvoiceDocument(null);
                }}
                style={{
                  color: AppColors.danger,
                }}
              />
            </div>
          )}
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Bỏ qua', onCancel, null)}
        {UIHelper.buildGreenButton('Cập nhật', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogUpdateEnergyBillView;
